module.exports = __webpack_public_path__ + "img/ro.b629e7a8.svg";